<template>
  <div>
    <v-row class="mt-2">
      <v-col cols="12">
        <!-- first heading row with btn -->
        <v-row>
          <v-col cols="12">
            <v-card class="mx-2">
              <v-row class="mx-2" justify="end">
                <v-col cols="12" md="9">
                  <h2 class="text-left">Finance Dashboard</h2>
                </v-col>

                <v-col cols="12" md="3" align-self="center" >
                  <v-row justify="center" v-if="currentUser.privileges.canManageFinanceSettings">
                    <!-- <v-col> -->
                    <v-btn
                      color="primary"
                      :to="{ name: 'FinanceSettings' }"
                      class="my-2"
                    >
                      Finance Settings
                    </v-btn>
                    <!-- </v-col> -->
                  </v-row>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col
                  cols="12"
                  md="3"
                  sm="4"
                  v-for="item in dashboardCardItems"
                  :key="item.id"
                >
                  <v-card class="py-8 mx-4 my-4 px-8" :to="{ name: item.url }">
                    <h3 class="text--secondary text-left font-weight-medium">
                      {{ item.title }}
                    </h3>
                  </v-card>
                </v-col>
              </v-row>

              <v-row class="mx-2" justify="end" v-if="currentUser.privileges.canViewFeeReports || currentUser.privileges.canViewFinanceTransactionReports">
                <v-col cols="9">
                  <h2 class="text-left">Finance Reports</h2>
                </v-col>
                <v-col cols="3"> </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col
                  cols="12"
                  md="3"
                  sm="4"
                  v-for="item in reportCardItems"
                  :key="item.id"
                >
                  <v-card
                    class="py-8 mx-4 my-4 px-8"
                    :to="{
                      name: item.url,
                      query: item.query ? item.query : null,
                    }"
                  >
                    <h3 class="text--secondary text-left font-weight-medium">
                      {{ item.title }}
                    </h3>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <!-- snackbar -->
    <v-snackbar
      v-model="snackbar.visible"
      timeout="5000"
      :color="snackbar.color"
      multi-line
    >
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snackbar.visible = false"
          >Close</v-btn
        >
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import TourHelper from "@utils/tour_helper";
// import ConfirmationDialog from "@components/widgets/dialogs/ConfirmationDialog";
// import endpoints from "@api/repository";
// import api from "@api/index";

export default {
  name: "FinanceDashboard",

  components: {},

  data() {
    return {
      snackbar: {
        visible: false,
        message: "",
        color: "dark",
      },

      dashboardCardItems: [
        
        {
          id: 1,
          title: "All Accounts",
          url: "AllFinanceAccounts",
          requiredPermission: "canViewFinanceAccounts",
        },
        {
          id: 2,
          title: "All Transactions",
          url: "AllTransactions",
          requiredPermission: "canViewAllFinanceTransactions",
        },
        {
          id: 3,
          title: "Income",
          url: "Incomes",
          requiredPermission: "canViewFinanceIncomeTransactions",
        },
        {
          id: 4,
          title: "Expenses",
          url: "Expenses",
          requiredPermission: "canViewFinanceExpenseTransactions",
        },
         {
          id: 5,
          title: "Authorize Expenses",
          url: "AuthorizeExpenses",
          requiredPermission: "canAuthorizeFinanceExpenseTransactions",
        },
      ],

      reportCardItems: [
        {
          id: 5,
          title: "Transactions Report",
          url: "TransactionsReport",
          query: { step: 1 },
          requiredPermission: "canViewFinanceTransactionReports",
        },
        {
          id: 6,
          title: "Compare Transactions",
          url: "TransactionsReport",
          query: { step: 4 },
          requiredPermission: "canViewFinanceTransactionReports",
        },
        {
          id: 7,
          title: "Category Summary",
          url: "TransactionsReport",
          query: { step: 2 },
          requiredPermission: "canViewFinanceTransactionReports",
        },
        {
          id: 8,
          title: "Accounts Summary",
          url: "TransactionsReport",
          query: { step: 3 },
          requiredPermission: "canViewFinanceTransactionReports",
        },        
        {
          id: 9,
          title: "Fee Reports",
          url: "FeeReports",
          requiredPermission: "canViewFeeReports",
        },
        // {
        //   id: 8,
        //   title: 'Payroll Reports',
        //   url: 'Dashboard'
        // },
        // {
        //   id: 9,
        //   title: 'Inventory Reports',
        //   url: 'Dashboard'
        // },
      ],
    };
  },

  computed: {
    ...mapGetters(["currentUser", "accessToken", "isLoading"]),
    essentials() {
      return {
        accessToken: this.accessToken,
        setLoading: this.setLoading,
        handleErrorsFunction: this.handleApiErrors,
      };
    },
  },

  methods: {
    ...mapActions(["setLoading"]),

    handleTour() {
        var steps = [];
        steps.push({id: '1', title: "Welcome to Finance Dashboard", description: "Take a glimpse of all your Finance modules present in this Section.", videoLink: "https://youtube.com"});
        TourHelper.startTour(this, "finance__dashboard", steps);
    },

    // handle api errors
    async handleApiErrors(err) {
      this.setLoading(false);
      console.log(err);
      if (err.response) {
        this.snackbar.message = "Unable to process request";
        this.snackbar.color = "error";
        this.snackbar.visible = true;
      }
    },

    filterDashboardCardItems(){
      this.dashboardCardItems = this.dashboardCardItems.filter(x => this.currentUser.privileges[x.requiredPermission])
    },

    filterReportItems(){
      this.reportCardItems = this.reportCardItems.filter(x => this.currentUser.privileges[x.requiredPermission])
    }
  },

  created() {
    this.filterDashboardCardItems();
    this.filterReportItems();
    this.handleTour();
  },
};
</script>

<style scoped>
.group-card {
  word-wrap: break-word;
}
</style>